// extracted by mini-css-extract-plugin
export default {"container":"WithdrawRequest_container__w4QRR","title":"WithdrawRequest_title__ipyAc","row":"WithdrawRequest_row__QNa9w","block":"WithdrawRequest_block__HCJc4"};